import { useSelector } from "react-redux";
import { languages } from "../config/config";

export default () => {
  const { language } = useSelector((state) => state.content);

  const isArabic = language === languages?.arb;
  // const isArabic = true;

  const TextWeight = {
    bold: isArabic ? "almarai-bold" : "shubbak-bold",
    semiBold: isArabic ? "almarai-bold" : "shubbak-semibold",
    medium: isArabic ? "almarai-bold" : "shubbak-medium",
    regular: isArabic ? "almarai-regular" : "shubbak-regular",
    light: isArabic ? "almarai-light" : "shubbak-light",
    extraBold: isArabic ? "almarai-extra-bold" : "shubbak-black",

    sarSymbol: 'saudi-riyal',
  };

  const TextAlign = isArabic ? "text-right" : "text-left";

  const direction = isArabic ? "rtl" : "ltr";

  return { isArabic, TextWeight, TextAlign, direction };
};
